import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, } from 'antd';
import moment from 'moment';
import { dataDefault } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import TableText from "../../TableText";
import compute from "./compute";
import { numConvert, sum } from '../../../../method';
import getJson from '../../../../method/getJson';

const { MonthPicker } = DatePicker;
const totalIndex = [0, 3, 14, 25, 46, 47];
Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            note: { note: "" },
            loading: true,
            loadingSave: false,
            print: false,
            data5_1_3: []
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.update && nextProps.update != this.props.update) {
            this.setState({
                data: [],
                loading: true,
            });
            this.getData(this.state.date);
        }
    }


    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data) => {
        data = compute([...data]);
        data[47].total = (data[46].total - sum([
            getJson([2, 'REV'], this.state.data5_1_3),
            getJson([14, 'REV'], this.state.data5_1_3)
        ])).toFixed(2);
        this.setState({
            data
        });
        this.props.onChange(false);
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    // 获取表格5_6_1内容
    getData = (date) => {
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);
        const listname = ['meet', 'space', 'no', 'sold', 'total'];
        fetch(`/_6_2_2?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            data.forEach((item, i) => {
                listname.forEach(name => {
                    if (i != 47) {
                        data[i][name] = (x.data.data || []).filter(v => v.sort === item.sort).reduce((a, b) => {
                            a += numConvert(b[name]);
                            return a
                        }, 0).toFixed(2);
                    }
                });
            });

            this.setState({ loading: false, data5_1_3: x.data.data5_1_3 || [] }, () => {
                this.computeNum(data);
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table6_2_2', 1.5, '6.22', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }


    render() {
        const { data, date } = this.state;
        const columns = [{
            title: <div>Meeting Room/Ballroom <br /> 会议室/宴会厅</div>,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }

                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Meeting/Banquet Space SQM <br /> 场地面积（平方米）</div>,
            dataIndex: 'meet',
            key: 'meet',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "meet", onChange: this.onChange, totalIndex,
                    // compared: {
                    //     title: ['Meeting/Banquet Space SQM <br /> 场地面积（平方米）'],
                    //     record,
                    //     sqlName: "_6_2_new"
                    // }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }

                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Space Available SQM<br /> 可售总面积（平方米）</div>,
            dataIndex: 'space',
            key: 'space',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "space", onChange: this.onChange, totalIndex,
                    // compared: {
                    //     title: ['Space Available SQM<br /> 可售总面积（平方米）'],
                    //     record,
                    //     sqlName: "_6_2_new"
                    // }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }

                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>No. of Meeting/Events <br /> 会议场次</div>,
            dataIndex: 'no',
            key: 'no',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "no", onChange: this.onChange, totalIndex,
                    // compared: {
                    //     title: ['No. of Meeting/Events <br /> 会议场次'],
                    //     record,
                    //     sqlName: "_6_2_new"
                    // }
                };

                let type = "number";
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }

                return <TableText data={{ ...props, type }} />
            }
        }, {
            title: <div>Sold Space<br /> 出售总面积（平方米）</div>,
            dataIndex: 'sold',
            key: 'sold',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "sold", onChange: this.onChange, totalIndex,
                    // compared: {
                    //     title: ['Sold Space<br /> 出售总面积（平方米）'],
                    //     record,
                    //     sqlName: "_6_2_new"
                    // }
                };

                let type = "number";
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }

                return <TableText data={{ ...props, type }} />
            }
        }, {
            title: <div>Space Occupancy<br /> 会议场地出租率</div>,
            dataIndex: 'occ',
            key: 'occ',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "occ", type: "percent", onChange: this.onChange, totalIndex,
                    // compared: {
                    //     title: ['Space Occupancy<br /> 会议场地出租率'],
                    //     record,
                    //     sqlName: "_6_2_new"
                    // }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }

                return <TableText data={{ ...props, }} />
            }
        }, {
            title: <div>Total Catering Revenue<br /> 宴会活动总收入</div>,
            dataIndex: 'total',
            key: 'total',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "total", onChange: this.onChange, totalIndex,
                    // compared: {
                    //     title: ['Total Catering Revenue<br /> 宴会活动总收入'],
                    //     record,
                    //     sqlName: "_6_2_new"
                    // }
                };

                let type = "number";

                return <TableText data={{ ...props, type }} />
            }
        }, {
            title: <div>S/C<br /> 每平方米平均消费</div>,
            dataIndex: 'sc',
            key: 'sc',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "sc", type: "number", onChange: this.onChange, totalIndex,
                    // compared: {
                    //     title: ['S/C<br /> 每平方米平均消费'],
                    //     record,
                    //     sqlName: "_6_2_new"
                    // }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }

                return <TableText data={{ ...props, }} />
            }
        }, {
            title: <div>RevPASP <br /> 可售场地面积平均收入</div>,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "rev", type: "number", onChange: this.onChange, totalIndex,
                    // compared: {
                    //     title: ['RevPASP <br /> 可售场地面积平均收入'],
                    //     record,
                    //     sqlName: "_6_2_new"
                    // }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }

                return <TableText data={{ ...props, }} />
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 height-52">

                    <Row className="title" id="table6_2_2"  >
                        <Row>6.2.2 YTD This Year 年累计本年</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getData(str)
                                }}
                            />
                            {
                                moment(date).format('YYYY') == 2019 && <span
                                    style={{ fontSize: 14, marginLeft: 10 }}
                                >
                                    2019年从7月开始累计数据
                                </span>
                            }
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            scroll={this.state.print ? {} : { y: 500 }}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_6_2">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/6.0/6-2/6.2.2.js